export const VueMobileDesktopMixin = {
	data () {
		return {
			isMobile: false,
			isDesktop: false
		}
	},
	mounted () {
		if (typeof window !== 'undefined') {
			navigator.onLine ? this.isOnline = true : this.isOffline = true;

			var isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
			if (isIPadPro) {
				this.isMobile = true;
				this.isDesktop = false;
			} else {
				if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|iphone|ipad|ipod|Safari/i.test(navigator.userAgent)) {
					if (/Mobile/i.test(navigator.userAgent)) {
						this.isMobile = true;
					} else {
						this.isDesktop = true;
					}
				} else {
					this.isDesktop = true;
				}
			}

			const onmobileHandler = () => {
				this.$emit('mobile');
				this.isMobile = true;
				this.isDesktop = false;
			};

			const ondesktopHandler = () => {
				this.$emit('desktop');
				this.isMobile = false;
				this.isDesktop = true;
			};

			window.addEventListener('mobile', onmobileHandler)
			window.addEventListener('desktop', ondesktopHandler)

			this.$once('hook:beforeDestroy', () => {
				window.removeEventListener('mobile', onmobileHandler)
				window.removeEventListener('desktop', ondesktopHandler)
			})
		}
	}
}

function _addKey (newKey) {
	let keys = JSON.parse(localStorage.getItem('VueMobileDesktop')) || [];
	if (!keys.includes(newKey)) keys.push(newKey)
	localStorage.setItem('VueMobileDesktop', JSON.stringify(keys))
}

export const VueMobileDesktopStorage = {
	keys: typeof window !== 'undefined' ? localStorage.getItem('VueMobileDesktop') : null,
	set (key, value) {
		if (typeof window !== 'undefined') {
			localStorage.setItem(key, JSON.stringify(value))
			_addKey(key)
		}
	},
	get (key) {
		return typeof window !== 'undefined' ? JSON.parse(localStorage.getItem(key)) : null
	}
}

export const VueMobileDesktop = {
	install (Vue, options = {mixin: true, storage: true}) {
		const pluginOptions = {
			mixin: options.mixin,
			storage: options.storage
		};
		if (pluginOptions.storage) Vue.prototype.$isMobileDesktopStorage = VueMobileDesktopStorage
		if (pluginOptions.mixin) Vue.mixin(VueMobileDesktopMixin)
	}
}

export default VueMobileDesktop
